import { XApp } from '@core/utils';
import { RACCOON_ID } from '../index';

export default XApp.createi18nStaticTranslator(RACCOON_ID);
